var _circle, _path, _path2, _circle2, _g, _circle3, _g2, _circle4, _g3, _circle5, _g4, _circle6, _g5, _circle7, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgConservativeEsg = function SvgConservativeEsg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 59,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.826,
    cy: 28.592,
    r: 28.472,
    fill: "#EFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M132.012 35.175c7.364 0 13.311-5.831 13.311-12.99-7.335-.027-13.311 5.804-13.311 12.99M117.59 22.185c0 7.186 5.976 12.99 13.312 12.99 0-7.158-5.977-12.99-13.312-12.99M132.012 48.17c7.364 0 13.311-5.832 13.311-12.99-7.335-.028-13.311 5.803-13.311 12.99M117.59 35.18c0 7.185 5.976 12.99 13.312 12.99 0-7.159-5.977-12.99-13.312-12.99M132.012 22.008c7.364 0 13.311-5.831 13.311-12.99-7.335-.027-13.311 5.804-13.311 12.99M117.59 9.018c0 7.186 5.976 12.99 13.312 12.99 0-7.158-5.977-12.99-13.312-12.99"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-esg_svg__a",
    width: 117,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.373.12h116.38v57.151H.373z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-esg_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "conservative-esg_svg__b",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-esg_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EEC0",
    stroke: "#C0EEC0",
    d: "m53.49 53.089 3.41-1.2L39.975 2.331l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-esg_svg__c",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-esg_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    stroke: "#92DE63",
    d: "M56.85 49.98 39.957.005 58.36-4.25 77.44-.437l-16.43 50.67z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-esg_svg__d",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-esg_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    stroke: "#125A42",
    d: "M106.681 22.935 68.068 49.31l3.868 7.525h46.348l-3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-esg_svg__e",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 58.901,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-esg_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    stroke: "#EFE",
    d: "M10.445 22.935 49.057 49.31l-3.869 7.525H-1.159l3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "conservative-esg_svg__f",
    width: 117,
    height: 118,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 58.901,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#conservative-esg_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    stroke: "#169B62",
    d: "m64.927 51.686-3.429-1.143L77.599.71l18.484 8.671 10.862 13.722z"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.562,
    cy: 58.907,
    r: 26.263,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#125A42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m47.641 46.328 1.042-5.296 5.419 1.066M58.903 55.847l-9.367-13.583"
  })));
};
export { SvgConservativeEsg as ReactComponent };
export default __webpack_public_path__ + "images/conservative-esg.svg";